import styled from 'styled-components';

export const ImputStyle = styled.input`
  background: #fff;
  border-radius: 5px;
  border: 1px solid #9D9D9C;
  padding: 16px;
  width: 100%;
  color: #232129;
  margin-bottom: 10px;

  & + input {
    margin-top: 8px;
  }

  ${({disabled}) => disabled && `
    color: #9D9D9C;
  `}
`;